<template>
  <div v-if="dataIsMounted" class="ui-input">
    <div v-if="editor" class="flex flex-wrap gap-2 border-b pb-2">
      <ui-button
        :disabled="!editor.can().chain().focus().toggleBold().run()"
        :class="{ 'active': editor.isActive('bold') }"
        class="icon"
        svg="fa fa-bold"
        @click="editor.chain().focus().toggleBold().run()"
        />
      <ui-button
        :disabled="!editor.can().chain().focus().toggleItalic().run()"
        :class="{ 'active': editor.isActive('italic') }"
        class="icon"
        svg="fas fa-italic"
        @click="editor.chain().focus().toggleItalic().run()"
        />
      <ui-button
        :disabled="!editor.can().chain().focus().toggleStrike().run()"
        :class="{ 'active': editor.isActive('strike') }"
        class="icon"
        svg="fa fa-strikethrough"
        @click="editor.chain().focus().toggleStrike().run()"
        />
      <ui-button
        :disabled="!editor.can().chain().focus().toggleCode().run()"
        :class="{ 'active': editor.isActive('code') }"
        class="icon"
        svg="fa fa-code"
        text="Inline"
        @click="editor.chain().focus().toggleCode().run()"
        />
      <ui-button
        :class="{ 'active': editor.isActive('codeBlock') }"
        class="icon"
        svg="fa fa-code"
        text="Block"
        @click="editor.chain().focus().toggleCodeBlock().run()"
        />
      <ui-button
        class="icon"
        svg="fa fa-eraser"
        @click="editor.chain().focus().unsetAllMarks().run()"
        >
        Unformat
      </ui-button>
      <ui-button
        :class="{ 'active': editor.isActive('paragraph') }"
        class="icon"
        svg="fa fa-paragraph"
        @click="editor.chain().focus().setParagraph().run()"
        />
      <ui-button class="icon !pr-0">
        h
        <span
          v-for="(v,i) in Array(6)"
          :key="'heading_'+(i+1)"
          class="px-2 py-2 border-r hover:bg-gray-200"
          :class="{
            'border-l ml-2': i === 0,
            'border-r-0': i === 5,
            'active': editor.isActive('heading', { level: (i+1) })
          }"
          @click="editor.chain().focus().toggleHeading({ level: (i+1) }).run()"
          v-text="(i+1)"
          />
      </ui-button>
      <!-- <ui-button
				:class="{ 'active': editor.isActive('heading', { level: 1 }) }"
				@click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
				>
				h1
			</ui-button>
			<ui-button
				:class="{ 'active': editor.isActive('heading', { level: 2 }) }"
				@click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
				>
				h2
			</ui-button>
			<ui-button
				:class="{ 'active': editor.isActive('heading', { level: 3 }) }"
				@click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
				>
				h3
			</ui-button>
			<ui-button
				:class="{ 'active': editor.isActive('heading', { level: 4 }) }"
				@click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
				>
				h4
			</ui-button>
			<ui-button
				:class="{ 'active': editor.isActive('heading', { level: 5 }) }"
				@click="editor.chain().focus().toggleHeading({ level: 5 }).run()"
				>
				h5
			</ui-button>
			<ui-button
				:class="{ 'active': editor.isActive('heading', { level: 6 }) }"
				@click="editor.chain().focus().toggleHeading({ level: 6 }).run()"
				>
				h6
			</ui-button> -->
      <ui-button
        :class="{ 'active': editor.isActive('bulletList') }"
        class="icon"
        svg="fa fa-list-ul"
        @click="editor.chain().focus().toggleBulletList().run()"
        />
      <ui-button
        :class="{ 'active': editor.isActive('orderedList') }"
        class="icon"
        svg="fa fa-list-ol"
        @click="editor.chain().focus().toggleOrderedList().run()"
        />
      <ui-button
        :class="{ 'active': editor.isActive('blockquote') }"
        class="icon"
        svg="fa fa-quote-right"
        @click="editor.chain().focus().toggleBlockquote().run()"
        />
      <ui-button
        class="icon"
        svg="fa fa-minus"
        text="hr"
        @click="editor.chain().focus().setHorizontalRule().run()"
        />
      <ui-button
        class="icon"
        svg="fa fa-level-down-alt"
        @click="editor.chain().focus().setHardBreak().run()"
        >
        hard break
      </ui-button>
      <ui-button
        :disabled="!editor.can().chain().focus().undo().run()"
        class="icon"
        svg="fa fa-undo"
        @click="editor.chain().focus().undo().run()"
        />
      <ui-button
        :disabled="!editor.can().chain().focus().redo().run()"
        class="icon"
        svg="fa fa-redo"
        @click="editor.chain().focus().redo().run()"
        />
    </div>
    <TiptapEditorContent
      :editor="editor"
      />
  </div>
</template>

<script setup>
const model = defineModel();

const dataIsMounted = ref(false);
const editor = useEditor({
  content: '',
  extensions: [TiptapStarterKit],
});

onMounted(() => {
  editor.value?.commands.setContent(model.value);

  dataIsMounted.value = true;
});

onBeforeUnmount(() => {
  unref(editor.value)?.destroy();
});

watchEffect(() => {
  if (!dataIsMounted.value) return;

  model.value = unref(editor.value)?.getHTML();
});

watch(() => model.value, () => {
  if (!dataIsMounted.value) return;

  nextTick(() => {
    nextTick(() => {
      if (editor.value?.isFocused) {
        return;
      }
      console.log('Tiptap set', model.value)
      editor.value?.commands.setContent(model.value);
    })
  })
});
</script>

<style scoped lang="scss">
.ProseMirror-focused {
	&:focus-visible {
		outline: none;
	}
}
</style>
